import debounce from 'lodash/debounce.js'
export const setDomFontSize = () => {
  const width =
    document.documentElement.clientWidth || document.body.clientWidth
  const fontSize = (width <= 1200 ? 1200 : width) / 100 + 'px'
  document.getElementsByTagName('html')[0].style['font-size'] = fontSize
}

// 防抖
const setDomFontSizeDebounce = debounce(setDomFontSize, 500)

window.addEventListener('resize', setDomFontSizeDebounce)
